import { init } from '@/animations/sal/sal.core';

function initSAL() {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  window.sal = init({
    disabled: prefersReducedMotion.matches,
    once: false,
    threshold: 0.1,
  });
}

// Initialize SAL
document.addEventListener('DOMContentLoaded', initSAL);
setTimeout(initSAL, 0);
